export default __webpack_public_path__ + "static/nft_placeholder-ec34b5b3a0170535b8344f14736bb4be.jpg";